import {useState} from "react";
import {useKeycloakFunctions} from "./useKeycloakFunctions";
import {userAccountsAPI} from "../common/api/userAccountsAPI";
import {API_DISQUS_SIGNATURE} from "../common/api/apiConstants";

export const useDisqusAuthSignature = () => {
    const {initialized, authenticated} = useKeycloakFunctions();
    const [data, setData] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();

    const getSignature = () => {
        setLoading(true);

        if (initialized && authenticated) {
            userAccountsAPI.get(API_DISQUS_SIGNATURE)
                .then(res => res.data)
                .then(response => {
                    setLoading(false);
                    setData(response?.signature);
                })
                .catch(err => {
                    setLoading(false);
                    setError(err);
                });
        }
    };

    return {
        getSignature,
        authSignature: data,
        loading,
        error
    };
};
